import { render } from "./ListeAvisPage.vue?vue&type=template&id=2404a794&ts=true"
import script from "./ListeAvisPage.vue?vue&type=script&lang=ts"
export * from "./ListeAvisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__